import * as apicall from "../components/Apicall";

/* The vendor's own time-slot list for a day (no service provider needed): the times a booking can
   start and how busy each is. See utilstop_apiengine/src/routes/vendorSlots. */

// Resolves { success, data: { date, slot_minutes, open, close, closed, slots[] } }; rejects on a
// network/400 error (apicall.get throws with the server's message).
export const getVendorTimeSlots = ({ date, serviceId, duration, excludeGroupId }) => {
  const params = new URLSearchParams({ date });
  if (serviceId) params.set("service_id", serviceId);
  if (duration) params.set("duration", Math.round(Number(duration)) || "");
  if (excludeGroupId) params.set("exclude_group_id", excludeGroupId);
  return apicall.get(`vendor_time_slots?${params.toString()}`);
};
